<script lang="ts">
	export let content: string;
</script>

<div class="outline">
	<p class="content">
		{@html content}
	</p>
</div>

<style lang="scss">
	@import '$styles/vars';
	
	.outline {
		padding: 24px 24px 12px 24px;
		background-color: $light-grey;
		border-radius: 12px;
		margin: 0 0 24px;
		.content {
	  	font-weight: 600;
		}
	}

  @media (max-width: $portrait-phone-size) {
		.outline {
	  	padding: 24px 12px 12px 12px;
	  	.content {
				padding-top: 0;
			}
		}
	}
</style>
